import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es'
  },
  icons: {
    iconfont: 'fa'
  },
  theme: {
    themes: {
      light: {
        primary: '#000000', // Azul #4180FF
        secondary: '#F8F100', // Amarillo
        accent: '#26A69A', // Verde
        error: '#4180FF' // Gris
      }
    }
  }
})
